import { createFileRoute, redirect } from "@tanstack/react-router";
import { CURRENT_LEAGUE_SLUG } from "@/lib/league";

export const Route = createFileRoute("/leaderboard")({
  beforeLoad: () => {
    throw redirect({ to: "/$league", params: { league: CURRENT_LEAGUE_SLUG } });
  },
});
